import * as React from "react";

import { cn } from "@/lib/utils";

/**
 * The one heading style on the profile page.
 *
 * <p>There were four: read-only fields used small muted semibold, the timezone used sentence-case
 * semibold, the name fields and most panels used the comic headline, and legends did their own
 * thing again. Read down the page, that turns a list of settings into a list of unrelated widgets:
 * weight and colour imply a hierarchy that does not exist, because every one of these is just a
 * section of one form.</p>
 *
 * <p>So: one class, exported as well as wrapped, because a {@code <legend>} and a {@code <label>}
 * cannot both be this component but must both look the same.</p>
 */
export const SECTION_LABEL = "font-comic-headline text-sm uppercase tracking-wide text-foreground";

export function SectionLabel({
  as: As = "span",
  className,
  children,
  ...rest
}: {
  /** `label` when it names a control, `legend` inside a fieldset, `span` otherwise. */
  as?: "span" | "label" | "legend" | "div";
  className?: string;
  children: React.ReactNode;
  // Label attributes rather than plain HTML ones, so `htmlFor` type-checks on `as="label"`.
} & React.LabelHTMLAttributes<HTMLElement>) {
  return (
    <As className={cn("block", SECTION_LABEL, className)} {...rest}>
      {children}
    </As>
  );
}
